import axios from "@/libs/http";
/**
 * 圈子列表
 */
export const getClerkCircleList = (params) => {
  return axios.request({
    url: "/s/c/clerkCircle/list",
    params,
    method: "get",
  });
};
/**
 * 店员申请入圈
 */
export const applyCirCle = (data) => {
  return axios.request({
    url: "/s/c/circleApply/applycirCle",
    data,
    method: "post",
  });
};
/**
 * 店员申请退圈
 */
export const exitCircle = (data) => {
  return axios.request({
    url: "/s/c/circleApply/exitCircle",
    data,
    method: "post",
  });
};
/**
 * 获取店员视频
 */
export const getUrlByClerk = (params) => {
  return axios.request({
    url: "/s/c/circleApply/getUrlByClerk",
    params,
    method: "get",
  });
};
